// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6229d4cb","821":"0346ac01"}[chunkId] + ".chunk.js";
};